<template>
  <div>
    <!--loading on cross quotes-->
    <div
      v-if="!crossQuotesMapped"
      class="loading-indicator d-flex justify-center align-center  flex-gow-1"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        :size="50"
        :width="5"
      >
      </v-progress-circular>
      <span class="ml-3 text-h4">{{ $t('extras.loadingDot') }} </span>
    </div>

    <div v-else class="cross-quotation-table ml-3" >
      <v-simple-table class="table" >
        <template v-slot:default>
          <thead>
            <tr>
              <th></th>
              <th class="text-center ">
                <div class="d-flex justify-center align-center">
                  <v-img
                 
                  content-class="rounded-lg"
                  class="rounded-lg mr-2" 
                  :height="imgSize"
                  :width="imgSize"
                  :max-width="imgSize"
                  contain
                  :src="require(`./../assets/usd_flag.png`)"
                  />
                  <span>USD</span>
                </div>
              </th>
              <th class="text-center ">
                <div class="d-flex justify-center align-center">
                  <v-img
                    
                    content-class="rounded-lg"
                    class="rounded-lg mr-2"
                    :height="imgSize"
                    :width="imgSize"
                    :max-width="imgSize"
                    contain
                    :src="require(`./../assets/eu_flag.png`)"
                  />
                  <span>EUR</span>
                </div>
              </th>
              <th class="text-center ">
                <div class="d-flex justify-center align-center">
                  <v-img
                    :height="imgSize"
                    content-class="rounded-lg"
                    class="rounded-lg mr-2"
                    contain
                    :max-width="imgSize"
                    :width="imgSize"
                    :src="require(`./../assets/japan_flag.png`)"
                  />
                  <span>JPY</span>
                </div>
              </th>
              <th class="text-center ">
                <div class="d-flex justify-center align-center">
                  <v-img
                    :height="imgSize"
                    content-class="rounded-lg"
                    class="rounded-lg mr-2"
                    contain
                    :max-width="imgSize"
                      width="20"
                    :src="require(`./../assets/brazil_flag.png`)"
                  />
                  <span>BRL</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody :style="{ '--news-font-size': fontsSetting.getFontSize * '11' + 'px' }">
            <template v-if="crossQuotesMapped">
              <tr v-for="(quote, index) in crossQuotesMapped" :key="quote.fromCcy" class="text-center">
                <td class="">
                  <div class="d-flex justify-center align-center">
                    <v-img
                      v-if="quote.fromCcy === 'USD'"
                      :height="imgSize"
                      content-class="rounded-lg"
                      class="rounded-lg mr-2"
                      contain
                      :max-width="imgSize"
                      width="20"
                      :src="require(`./../assets/usd_flag.png`)"
                    />
                    <v-img
                      v-else-if="quote.fromCcy === 'EUR'"
                      :height="imgSize"
                      content-class="rounded-lg"
                      class="rounded-lg mr-2"
                      contain
                      :max-width="imgSize"
                      width="20"
                      :src="require(`./../assets/eu_flag.png`)"
                    />
                    <v-img
                      v-else-if="quote.fromCcy === 'JPY'"
                    
                      content-class="rounded-lg"
                      class="rounded-lg mr-2"
                      contain
                      :height="imgSize"
                      :width="imgSize"
                      :max-width="imgSize"
                      :src="require(`./../assets/japan_flag.png`)"
                    />
                    <v-img
                      v-else-if="quote.fromCcy === 'BRL'"
                      content-class="rounded-lg"
                      class="rounded-lg mr-2"
                      contain
                      :height="imgSize"
                      :width="imgSize"
                      :max-width="imgSize"
                      :src="require(`./../assets/brazil_flag.png`)"
                    />
                    <span>{{ quote.fromCcy }}</span>
                  </div>
                </td>
                <td
                  :class="{
                    'empty': !quote.values['USD'] || quote.values['USD'] === crossQuotesData[index].values['USD'],
                    'orangeColor--text': quote.values['USD'] < crossQuotesData[index].values['USD'],
                    'alive--text': quote.values['USD'] > crossQuotesData[index].values['USD']
                  }"
                  :style="{
                    backgroundColor: 
                      quote.values['USD'] < crossQuotesData[index].values['USD'] ? 
                      yellowTransp : 
                        (quote.values['USD'] > crossQuotesData[index].values['USD'] ? 
                          aliveTransp : '')
                  }"
                  class="text-center align-center "
                >
                  {{ formatQuotes(quote.values["USD"])  }}
                </td>
                <td
                  :class="{
                    'empty': !quote.values['EUR'] || quote.values['EUR'] === crossQuotesData[index].values['EUR'],
                    'orangeColor--text': quote.values['EUR'] < crossQuotesData[index].values['EUR'],
                    'alive--text': quote.values['EUR'] > crossQuotesData[index].values['EUR']
                  }"
                  :style="{
                    backgroundColor: 
                      quote.values['EUR'] < crossQuotesData[index].values['EUR'] ? 
                      yellowTransp : 
                        (quote.values['EUR'] > crossQuotesData[index].values['EUR'] ? 
                          aliveTransp : '')
                  }"
                  class="text-center align-center "
                >
                  {{ formatQuotes(quote.values["EUR"])  }}
                </td>
                <td
                  :class="{
                    'empty': !quote.values['JPY'] || quote.values['JPY'] === crossQuotesData[index].values['JPY'],
                    'orangeColor--text': quote.values['JPY'] < crossQuotesData[index].values['JPY'],
                    'alive--text': quote.values['JPY'] > crossQuotesData[index].values['JPY']
                  }"
                  :style="{
                    backgroundColor: 
                      quote.values['JPY'] < crossQuotesData[index].values['JPY'] ? 
                      yellowTransp : 
                        (quote.values['JPY'] > crossQuotesData[index].values['JPY'] ? 
                          aliveTransp : '')
                  }"
                  class="text-center align-center "
                >
                  {{ formatQuotes(quote.values["JPY"])  }}
                </td>
                <td
                  :class="{
                    'empty': !quote.values['BRL'] || quote.values['BRL'] === crossQuotesData[index].values['BRL'],
                    'orangeColor--text': quote.values['BRL'] < crossQuotesData[index].values['BRL'],
                    'alive--text': quote.values['BRL'] > crossQuotesData[index].values['BRL']
                  }"
                  :style="{
                    backgroundColor: 
                      quote.values['BRL'] < crossQuotesData[index].values['BRL'] ? 
                      yellowTransp : 
                        (quote.values['BRL'] > crossQuotesData[index].values['BRL'] ? 
                          aliveTransp : '')
                  }"
                  class="text-center align-center"
                >
                  {{  formatQuotes(quote.values["BRL"]) }}
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapWritableState } from "pinia";
import { useColorsStore,useSettingsStore } from "./../store/index";
import { useFxMarketStore } from "@/store/toolbarStore";

export default {
  data() {
    return {
      crossQuotes: [],
      crossQuotesData: [],
      interval: null,
      fontsSetting: useSettingsStore(),
    }
  },
  mounted() {
    this.fetchQuarterMinuteAndUpdate()
  },
  beforeDestroy () {
    clearInterval(this.interval)
  },
  methods: {
    formatQuotes(ccy)
    {
      return (ccy === 'NaN') || Number.isFinite(ccy)|| ccy === '0.0000' ? this.$t('extras.loadingDot') : ccy 
    },  
    ...mapActions(useFxMarketStore, [
      "getFxMarketDataQuarterMinute",
    ]),
    fetchFxMarketDataQuarterMinute() {
      const currencyPairs = [
        { fromCcy: "USD", toCcy: "EUR" },
        { fromCcy: "EUR", toCcy: "JPY" },
        { fromCcy: "JPY", toCcy: "USD" },
        { fromCcy: "JPY", toCcy: "BRL" },
        { fromCcy: "BRL", toCcy: "USD" },
        { fromCcy: "BRL", toCcy: "EUR" }
      ]

      this.getFxMarketDataQuarterMinute(currencyPairs)
        .then((response) => {
          const data = response.data
          const crossQuotes = data["fx-market-cross-quotes"]
          localStorage.setItem('crossQuotes', JSON.stringify(crossQuotes))
          this.crossQuotes = JSON.parse(localStorage.getItem("crossQuotes"))
          this.saveCrossQuotesData()
        })
        .catch((error) => {
          console.log(error)
        })
    },
    saveCrossQuotesData () {
      this.crossQuotesData = this.crossQuotesData.concat(this.crossQuotesMapped)
    },
    fetchQuarterMinuteAndUpdate () {
      const crossQuotes = JSON.parse(localStorage.getItem("crossQuotes"))
      if (crossQuotes !== null) {
        this.crossQuotes = crossQuotes
        this.saveCrossQuotesData()
      }
      this.fetchFxMarketDataQuarterMinute()
      this.interval = setInterval(this.fetchFxMarketDataQuarterMinute, 15000)
    }
  },
  computed: {
    ...mapState(useColorsStore, [
      "yellowTransp",
      "aliveTransp"
    ]),
    ...mapState(useFxMarketStore , [
      "getFxMarketIsLoading"
    ]),
    ...mapWritableState(useFxMarketStore, [
      "fxMarketLoading"
    ]),
    crossQuotesMapped () {
      const date = new Date()
      const timeZoneBRT = date.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })
      const allQuotes = this.crossQuotes.concat(
        this.crossQuotes.map((pair) => ({
          from_currency: pair.to_currency,
          to_currency: pair.from_currency,
          exchange_rate: 1 / pair.exchange_rate,
          last_refreshed: pair.last_refreshed,
          time_zone: timeZoneBRT
        }))
      )

      return allQuotes.reduce((result, cotation) => {
        const { from_currency, to_currency, exchange_rate } = cotation

        const fromCcy = result.find(m => m.fromCcy === from_currency) || {
          fromCcy: from_currency,
          values: {}
        }

        fromCcy.values[to_currency] = (1 / parseFloat(exchange_rate)).toFixed(4)
                
        if (!result.find(m => m.fromCcy === from_currency)) {
            result.push(fromCcy)
        }
        return result
      }, [])
    }
  },
props:{
      imgSize: {type:Number, default:20},
      fontSize:  {type:Number, default:10},

  }
}
</script>

<style scoped>
  .table {
    background-color: transparent;
    margin:auto;
  }
  

  .table th, .table td{
    font-size: var(--news-font-size) !important;
    height:15px !important;
    padding:.4rem .1rem!important;
  }


  table th {
    border: 1px solid #ffffff1f;
   
  }

  table td {
    border: 1px solid #ffffff1f;
  }

  .empty {
    background-color: rgb(30, 29, 29)
  }


</style>